import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 12px 0px 24px;
  border-radius: 1px;
  box-sizing: border-box;
  min-height: 64px;
  width: 100%;
  background: ${colors.white};
`;

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Message = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;

export const IconWrapper = styled.div`
  display: flex;
  margin-right: 8px;
  > svg {
    height: 30px;
    width: 100%;
  }
`;

export const ProgressBar = styled.div`
  margin-top: 8px;
  display: block;
  position: relative;
  height: 8px;
  width: 95%;
  background-color: ${colors.grey100};
  overflow: hidden;

  &::after {
    content: '';
    width: 100px;
    height: 8px;
    background: ${colors.green300};
    position: absolute;
    animation: upload 1.2s linear infinite;
  }

  @keyframes upload {
    0% {
      left: 0;
      transform: translateX(-100%);
    }
    100% {
      left: 100%;
      transform: translateX(0%);
    }
  }
`;
